<template>
    <header :class="{'app-header': !logoOnly}">
        <div class="container">
            <div class="d-flex align-items-center">
                <a :href="menuData.websiteUrl" class="pr-4 py-3 py-lg-0" :class="{'d-inline-block pr-3 pt-3': logoOnly}">
                    <IconScribbrLogo :color="'#15204F'" :width="`${logoWidth ? logoWidth : '9.125rem'}`" :height="`${logoHeight ? logoHeight : '2rem'}`" />
                </a>
                <TheMainMenu v-if="!logoOnly" :menu-items="menuData.mainMenuV2" />
                <div v-if="!logoOnly" class="text-right ml-2 d-none d-xl-block">
                    <a :href="menuData.rootUrl" class="btn btn-warning" v-text="$t('upload.name')" />
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import TheMainMenu from '../../components/Header/TheMainMenu';
import IconScribbrLogo from '../../components/IconScribbrLogo/IconScribbrLogo';
import loadTranslations from '../../js/Functions/loadTranslations';

export default {
    i18n: {
        messages: loadTranslations('top_menu'),
    },
    components: { TheMainMenu, IconScribbrLogo },
    props: {
        menuData: {
            required: true,
            type: Object,
        },
        logoOnly: {
            type: Boolean,
            required: false,
            default: false,
        },
        logoWidth: {
            type: String,
            required: false,
            default: '',
        },
        logoHeight: {
            type: String,
            required: false,
            default: '',
        },
    },
};
</script>

<style lang="scss">
.app-header {
  box-shadow: 0 2px 4px rgba(32, 47, 102, 0.12);
}
</style>
